import React from 'react';

import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';

/** 파트너 계정: 조합 관리 > 상세 > 투자정보 스켈레톤 */
const PartnerInvestSummarySkeleton = () => {
  return (
    <>
      <div css={titleStyle}>
        <Skeleton variant="text" width={80} />
      </div>
      <Skeleton
        variant="rectangular"
        height={100}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
          marginBottom: '40px',
        }}
      />
    </>
  );
};

export default PartnerInvestSummarySkeleton;
